import { put, call, delay } from 'redux-saga/effects';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../../configs';
import addFilterQueryWithCondition from '../../../../utils/addFilterQueryWithCondition';
import {
  loadWhitesListBegin,
  loadWhitesListFailed,
  loadWhitesListSuccessful,
  setBlackWhitesModuleStatus,
} from '../../actions';
import makeRequest, { getBodyJson } from '../../../../utils/makeRequest';
import { OK } from '../../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../../utils/rejectActionPromise';
import processError from '../../../../utils/processError';
import { isBlackWhitesModuleUnavailableStatus, normalizeBlackWhitesError } from './moduleStatus';

export default function* loadWhitesList(action) {
  try {
    const { payload = {} } = action;
    const {
      limit = DEFAULT_ITEMS_OF_PAGE,
      page = 1,
      filter,
    } = payload;
    let pool = {
      limit,
      page,
      type: 'WHITE',
    };
    if (typeof filter === 'object' && Object.keys(filter).length) {
      yield delay(LOADING_DELAY);
      pool = addFilterQueryWithCondition(filter, pool);
    }

    const url = `${BACKEND_URL}/proxy/black-white/v1/blackwhites/`;
    yield put(loadWhitesListBegin());

    const dataResponse = yield makeRequest(url, pool, action, 'GET', true);
    const data = yield getBodyJson(dataResponse, {});

    if (dataResponse.status === OK) {
      yield put(setBlackWhitesModuleStatus({ available: true, checked: true }));
      data.result = data.data;
      yield put(loadWhitesListSuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      const isUnavailable = isBlackWhitesModuleUnavailableStatus(dataResponse.status);
      yield put(setBlackWhitesModuleStatus({ available: !isUnavailable, checked: true }));
      const normalizedError = normalizeBlackWhitesError(dataResponse.status, data);
      yield put(loadWhitesListFailed());
      yield call(rejectActionPromise(action, normalizedError));
    }
  } catch (e) {
    yield put(setBlackWhitesModuleStatus({ available: false, checked: true }));
    yield put(loadWhitesListFailed());
    yield call(rejectActionPromise(action, normalizeBlackWhitesError(null, e)));
    yield processError(e);
  }
}
